import { constants } from '../../constants/common';
import { MasterConfigs } from '../../interfaces/entity';

export const availableSlotsConfig: MasterConfigs = {
  api: () => '/slots',
  title: 'Available Slots',
  isActionTab: true,
  maskClosable: false,
  modalTitle: (action) => action + ' Slots',
  getColumns: () => {
    return [
      {
        title: 'Slots For',
        dataIndex: 'slotsFor',
        key: 'slotsFor',
        render: (text) => {
          return text ? [text.firstName, text.lastName].join(' ') : '';
        }
      }
    ];
  },
  getFormColumns: () => {
    return [
      {
        label: 'Slots For',
        name: 'slotsFor',
        type: 'select',
        isCombo: true,
        rules: [{ required: true, message: 'Field is required' }],
      },
      {
        label: 'Slots',
        name: 'slots',
        type: 'form',
        span: 24,
        form: [
          {
            label: 'Day',
            name: 'day',
            type: 'select',
            children: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(ele => ({ name: ele, value: ele })),
            rules: [{ required: true, message: 'Field is required' }],
          },
          {
            label: 'Start Slot',
            name: 'startSlot',
            type: 'time',
            timePickerProps: {
              format: 'hh:mma'
            },
            rules: [{ required: true, message: 'Field is required' }],
          },
          {
            label: 'End Slot',
            name: 'endSlot',
            type: 'time',
            timePickerProps: {
              format: 'hh:mma'
            },
            rules: [{ required: true, message: 'Field is required' }],
          },
          {
            label: 'Each Slot For',
            name: 'eachSlotFor',
            type: 'select',
            children: [15, 20, 30, 40, 45, 60, 75, 90, 120].map(ele => ({ name: ele, value: ele })),
            rules: [{ required: true, message: 'Field is required' }],
          },
          {
            label: 'Not Available between',
            name: 'selectedSlots',
            type: 'select',
            selectProps: { mode: 'tags', maxTagCount: 3 },
            isCombo: true,
          },
        ]
      }
    ];
  },
  combo: [
    {
      name: 'slotsFor',
      api: '/users',
      idKey: '_id',
      render: (text) => constants.GET_FULL_NAME(text)
    },
    {
      name: 'selectedSlots',
      api: '/slots/available/list/',
      idKey: 'value',
      render: (text) => text.name,
      // paramValue: 'eachSlotFor',
      // onChange: 'eachSlotFor',
    },
    {
      name: 'approvalFrom',
      api: '/users/CEO/list',
      idKey: '_id',
      render: (text) => constants.GET_FULL_NAME(text)
    }
  ],
  getData: () => ({}),
  actions: [
    { name: 'Add Slot', actionType: 'Add' },
    { name: 'Return', actionType: 'Back' },
  ],
};
